module.exports = __webpack_public_path__ + "img/smarthue.f27961b2.svg";